import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authFeatureKey, AuthState } from '.';

export const selectAuth = createFeatureSelector<AuthState>(authFeatureKey);

export const selectIsLoggedIn = createSelector(selectAuth, (state: AuthState) => state.isLoggedIn);

export const selectUser = createSelector(selectAuth, (state: AuthState) => state.user);

export const selectLoginPageError = createSelector(
  selectAuth,
  (state: AuthState) => state.loginError
);

export const selectIsAdmin = createSelector(selectAuth, (state: AuthState) => {
  const user = state.user;
  if (user) {
    return user.isAdmin;
  }
  return false;
});
